import { FunifierEvent, FunifierWidgetRender } from "@/lib/funifier-client";
import { useCallback, useEffect, useMemo } from "react";

interface FunifierWidgetProps {
  id: string;
}

const FunifierWidget: React.FC<FunifierWidgetProps> = ({ id }) => {
  const widgetListener = useCallback(() => {
    try {
      FunifierWidgetRender(id);
      return true;
    } catch (e) {
      console.warn((e as Error).message);
      return false;
    }
  }, [id]);

  useEffect(() => {
    if (!widgetListener()) {
      document.addEventListener(FunifierEvent.READY, widgetListener);
    }
    return () => {
      document.removeEventListener(FunifierEvent.READY, widgetListener);
    };
  }, [widgetListener]);

  return useMemo(
    () => (
      <div id={`${id}__container`} className="w-full h-full border relative" />
    ),
    [id],
  );
};

export default FunifierWidget;
